import styled from 'styled-components';

import { interactiveCard } from '../../styles/mixins';

const Container = styled.div`
  ${interactiveCard}
  height: 20rem;
  display: flex;
  gap: 1.5rem;
  justify-content: stretch;
  overflow: hidden;

  h2 {
    margin-top: 0.5rem;
  }

  :hover img {
    transform: scale(1.05);
  }
`;

const Image = styled.img`
  object-fit: cover;
  transition: transform var(--dur-base) var(--ease-out);
  min-width: 220px;
  max-width: 220px;

  @media (max-width: 800px) {
    min-width: 45%;
    max-width: 45%;
  }
`;

const Description = styled.p`
  color: var(--ink-faint);
  margin-top: 0.5rem;
  width: 70%;
  flex: 1;
  padding-right: 2rem;
`;

export { Container, Image, Description };
